import cx from 'classnames';

type Props = {
    className?: string;
}

export const RequiredMark: React.FC<Props> = ({className}: Props) => <span className={cx(className, 'tw-text-alert')}>{'*'}</span>;
